<template>
  <div class="course-detail-content">
    <div class="base-padding breadcrumb-content-box">
      <div class="breadcrumb-box">当前位置：首页 / 课程管理 / <span style="cursor: pointer;" @click="onLinkList">课程</span> / {{ courseInfo.title || '' }}</div>
    </div>
    <div class="base-padding course-content-box">
      <div class="video-title">{{ currentChapters.title || '' }}</div>
      <div class="video-content-box">
        <div class="video-content" ref="videoHeightRef">
          <div class="video-box">
              <div class="image-box" v-if="!isPlay" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
              <div v-if="init && playerOptions.sources[0].src">
                <!-- <video ref="videoRef" :src="currentChapters.fileUrl" controls :poster="currentChapters.imgUrl" width="780" height="477"></video> -->
                <video-player
                  class="video-player vjs-custom-skin" 
                  ref="videoPlayer" 
                  :playsinline="true" 
                  :options="playerOptions"
                  @canplay="onPlayerCanplay($event)"
                  @pause="onPlayerPause($event)"
                  @ended="onPlayerEnded($event)"
                  @waiting="onPlayerWaiting($event)"
                  @playing="onPlayerPlaying($event)"
                  @statechanged="playerStateChanged($event)"
                  @canplaythrough="onCanPlayThrough"
                  @ready="playerReadied"
                >
                </video-player>
              </div>
            <!-- </div> -->
          </div>
          <div class="describe-box">
            <div class="title">{{ courseInfo.title || '' }}</div>
            <div class="totalDuration">
              <span>共{{ chaptersList.length }}节</span>
              <span style="margin-left: 18px;">{{ courseInfo.totalDuration }}</span>
            </div>
          </div>
        </div>
        <div class="video-chapter" :style="{'height': initChapterHeight + 'px'}">
          <div
            class="chapter-lsit"
            :class="activeIndex === index ? 'active' : ''"
            v-for="(item, index) in chaptersList"
            :key="item.id"
            @click="onChoseChapters(index)"
          >
            <div class="chapter">{{ item.number }}.{{ item.title }}</div>
            <div class="duration">时长：{{ item.duration }}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 18px;padding-left: 18px;">
      <div class="course-content-describe">
        <h6 class="content-title">课程简介</h6>
        <div class="content-article">{{ courseInfo.introduction || '无' }}</div>
        <h6 class="content-title" style="margin-top: 32px;">讲师简介</h6>
        <div class="teacher-box">
          <img v-if="courseInfo.teacherImgUrl" :src="courseInfo.teacherImgUrl" alt="" />
          <span v-if="courseInfo.teacherName">{{ courseInfo.teacherName }}</span>
        </div>
        <div class="content-article">{{ courseInfo.teacherIntroduction || '无' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player/src'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
 
import { GetwXGetCourseDetailInfoApi, EditModifyCourseBrowseApi, EditModifyWatchTimeApi, GetCourseChapterStudyTimeApi, GetCourseBrowseRecordsApi, GetCourseLearnRecordQueryApi } from "@api/ApiCourseManagement";
let oldChapterId = '',currentPlayedTime = 0,lastUpdateTime = 0,timer = null;
export default {
  name: "CourseList",
  components: {
    videoPlayer
  },
  data() {
    return {
      init: false,
      id: '',
      isFinish: false,
      initChapterHeight: 438,
      playStartTimes: 0,
      isPlay: false,
      loading: true,
      activeIndex: 0,
      courseInfo: {},
      chaptersList: [],
      playerOptions: {
        // height: "477px",
        width: "100%",
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放
        muted: false, // 默认情况下静音播放
        loop: false, // 是否视频一结束就重新开始
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据，auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值，值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小，换句话说，它将按比例缩放以适应其容器
        sources: [
          {
            type: "video/mp4", // 类型
            src: '' // url地址，在使用本地的资源时，需要用require()引入，否则控制台会报错
          }
        ],
        poster: "", // 设置封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息
        controlBar: {
          currentTimeDisplay: true,
          progressControl: true,  // 是否显示进度条
          playbackRateMenuButton: false, // 是否显示调整播放倍速按钮
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      }
    }
  },
  computed: {
    currentChapters() {
      return this.chaptersList[this.activeIndex] || {}
    }
  },
  methods: {
    onLinkList() {
      this.$router.push({
        path: '/CourseList'
      });
    },
    async loadData() {
      const res = await GetwXGetCourseDetailInfoApi(this.$route.query.id)
      const records = await GetCourseBrowseRecordsApi({courseId: this.$route.query.id})
      const totalDuration = this.transSecondToTime(res.course.totalMins || 0)
      this.courseInfo = {...res.course, totalDuration}
      this.chaptersList = res.chapters.map(item=> {
        return {
          ...item,
          duration: this.transSecondToTime(item.mins)
        }
      })
      if(records && records.length) {
        records.sort((itemA, itemB)=>new Date(itemB.browseDate).getTime() - new Date(itemA.browseDate).getTime())
        const index = this.chaptersList.findIndex(item=>item.id === records[0].courseChapterId)
        this.activeIndex = index === -1 ? 0 : index
        if(records[0].watchTime >= this.chaptersList[this.activeIndex].mins) {
          this.isFinish = true
          this.playStartTimes = 0
          lastUpdateTime = 0
        } else {
          this.isFinish = false
          this.playStartTimes = records[0].watchTime
          lastUpdateTime = records[0].watchTime
        }
        this.onPalyVideo()
      } else {
        this.isFinish = false
        this.playStartTimes = 0
        lastUpdateTime = 0
        this.activeIndex = 0
        this.getWatchHistory()
      }
    },
    async getWatchHistory() {
      const data = await GetCourseChapterStudyTimeApi({
        courseId: this.courseInfo.id,
        chapterId: this.currentChapters.id
      })
      if(data && data.length) {
        if(data[0].watchTime >= this.currentChapters.mins) {
          this.isFinish = true
          this.playStartTimes = 0
          lastUpdateTime = 0
        } else {
          this.isFinish = false
          this.playStartTimes = data[0].watchTime || 0
          lastUpdateTime = data[0].watchTime || 0
        }
      } else {
        this.isFinish = false
        this.playStartTimes = 0
        lastUpdateTime = 0
      }
      this.onPalyVideo()
    },
    transSecondToTime(mins) {
      const hour = Math.floor(mins / 3600)
      const minute = Math.floor((mins - hour * 3600) / 60)
      const second = mins - hour * 3600  - minute * 60
      return (hour ? (hour + '小时') : '') + (minute ? (minute + '分') : '') + (second ? (second > 9 ?  (second + '秒') : ('0' + second + '秒')) : '')
    },
    onChoseChapters(index) {
      if(this.activeIndex !== index) {
        if(this.isPlay) {
          this.init = false
          // clearInterval(timer)
          // timer = null
          // const currentTime = Math.floor(currentPlayedTime - lastUpdateTime + 0.2)
          // this.updateTime(currentTime)
          // // this.$refs.videoPlayer.player.pause();
          this.isPlay = false
          this.loading = true
          lastUpdateTime = 0
          this.activeIndex = index
          this.getWatchHistory()
        // } else {
        //   this.activeIndex = index
        //   this.$nextTick(()=> {
        //     this.playerOptions.sources[0].src = this.chaptersList[this.activeIndex].fileUrl
        //     this.playerOptions.poster = this.chaptersList[this.activeIndex].imgUrl
        //     this.isPlay = true
        //     this.loading = false
        //   })
        }
      }
    },
    onPalyVideo() {
      this.isPlay = true
      this.loading = false
      this.playerOptions.sources[0].src = this.chaptersList[this.activeIndex].fileUrl
      this.playerOptions.poster = this.chaptersList[this.activeIndex].imgUrl
      this.init = true
      this.$nextTick(()=> {
        this.initChapterHeight = this.$refs.videoHeightRef.clientHeight
      })
    },

    // 暂停回调
    onPlayerPause() {
      // console.log('我是暂停回调！！！！')
      // console.log(this.isFinish)
      if(this.isFinish) return
      clearInterval(timer)
      timer = null
      const currentTime = Math.floor(currentPlayedTime - lastUpdateTime + 0.2)
      this.updateTime(currentTime)
      if(currentPlayedTime - lastUpdateTime > 0.8) {
        lastUpdateTime = currentPlayedTime
      }
    },

    // 视频播完回调
    onPlayerEnded() {
      // console.log('视频播放完了！')
      // if(this.isFinish) return
      // const time = Math.round(this.currentChapters.mins - currentPlayedTime)
      // this.updateTime(time)
      // this.isFinish = true
      if(this.activeIndex === this.chaptersList.length - 1) {
        this.$message("本课程已看完！");
      } else {
        this.$message("本章节已看完，正在跳转下一章节！");
        setTimeout(()=> {
          const lastIndex = this.activeIndex + 1
          this.onChoseChapters(lastIndex)
        }, 1000)
      }
    },

    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting(player) {
      // console.log(player)
      // this.$refs.videoPlayer.player.play()
    },

    onPlayerCanplay(player) {
      oldChapterId = this.currentChapters.id
      player.play()
    },

    onCanPlayThrough() {
      // console.log(`更新浏览记录<章节id: ${this.currentChapters.id}>`)
      // 更新用户的浏览记录
      EditModifyCourseBrowseApi({
        courseId: this.courseInfo.id,
        chapterId: this.currentChapters.id
      })
    },

    // 已开始播放回调
    onPlayerPlaying($event) {
      if(this.isFinish) return
      timer = setInterval(()=> {
        const currentTime = Math.floor(currentPlayedTime - lastUpdateTime + 0.2)
        if(currentPlayedTime - lastUpdateTime > 0.8) {
          this.updateTime(currentTime)
          lastUpdateTime = currentPlayedTime
        }
      }, 30000)
    },

    //播放状态改变回调
    playerStateChanged(playerCurrentState) {
      if(this.isFinish) return
      if(playerCurrentState.timeupdate) {
        currentPlayedTime = playerCurrentState.timeupdate
      }
    },

    //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied(player) {
      // this.loading = false
      // this.isPlay = true
      player.currentTime(this.playStartTimes)
      player.play()
    },
    // 更新章节学习时间
    updateTime(time) {
      // console.log(`更新时间<章节id: ${oldChapterId}，观看时长：${time}>`)
      if(time <= 0) return
      EditModifyWatchTimeApi({}, {
        courseId: this.courseInfo.id,
        chapterId: oldChapterId,
        time
      })
    },
    handleBeforeUnload() {
      if(this.isPlay) {
        // this.$refs.videoPlayer.player.pause();
        // this.onPlayerPause()
      }
    }
  },
  created() {
    // this.loadData();
    // GetCourseLearnRecordQueryApi().then(res=>{})
  },
  activated() {
    if(this.$route.query.id) {
      this.playStartTimes = 0
      this.activeIndex = 0
      this.loadData();
    }
  },
  deactivated() {
    if(this.isPlay) {
      if(this.$refs.videoPlayer) {
        this.$refs.videoPlayer.player.pause()
      }
      // this.onPlayerPause()
      this.isPlay = false
      this.loading = true
      this.init = false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
// 禁止拖动进度条
// :deep(.vjs-progress-control) {
//   pointer-events: none !important;
// }

.course-detail-content {
  .base-padding {
    box-sizing: border-box;
    padding: 0 110px 30px;
  }
  .breadcrumb-content-box {
    width: 100%;
    height: 42px;
    line-height: 42px;
    background-color: #333333;
    font-size: 14px;
    color: #ABABAB;
    line-height: 42px;
  }
  .course-content-box {
    width: 100%;
    line-height: 42px;
    background-color: #191919;
    font-size: 14px;
    color: #ABABAB;
    line-height: 42px;
    .video-title {
      line-height: 68px;
      font-size: 24px;
      color: #DDDDDD;
    }
    .video-content-box {
      display: flex;
      .video-content {
        flex: auto;
        .video-box {
          width: 100%;
          // height: 477px;
          min-height: 350px;
          position: relative;
          .image-box {
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            position: absolute;
            z-index: 99;
            background: rgb(70,70,70);
            .imgUrl {
              width: 100%;
              height: 100%;
            }
            .dialog {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              z-index: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgba(70,70,70,0.65);
              cursor: pointer;
              .icon {
                width: 56px;
                height: 56px;
              }
            }
          }
        }
        .describe-box {
          width: 100%;
          height: 88px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 0 24px;
          background: #333333;
          border-radius: 0px 0px 0px 4px;
          box-sizing: border-box;
          .title {
            font-size: 16px;
            color: #FFFFFF;
            line-height: 21px;
          }
          .totalDuration {
            font-size: 14px;
            color: #CCCCCC;
            line-height: 19px;
            margin-top: 12px;
          }
        }
      }
      .video-chapter {
        flex: none;
        width: 240px;
        // height: 565px;
        overflow-y: auto;
        background: #191919;
        border-radius: 0px 4px 0px 0px;
        border: 1px solid #484848;
        border-left: none;
        box-sizing: border-box;
        .chapter-lsit {
          padding: 17px 20px 17px 42px;
          cursor: pointer;
          &:not(:last-child) {
            border-bottom: 1px solid #484848;
          }
          &.active {
            .chapter {
              color: #4C81F5;
            }
          }
          .chapter {
            font-size: 15px;
            color: #A8A8A8;
            line-height: 20px;
          }
          .duration {
            font-size: 12px;
            color: #666666;
            line-height: 16px;
            margin-top: 4px;
          }
        }
      }
    }
  }
}
.course-content-describe {
  padding: 18px 118px 38px;
  background-color: #fff;
  .content-title {
    font-weight: 600;
    font-size: 18px;
    color: #3D3D3D;
    line-height: 24px;
  }
  .content-article {
    font-weight: 400;
    font-size: 14px;
    color: #9E9E9E;
    line-height: 19px;
    margin-top: 18px;
  }
  .teacher-box {
    margin-top: 18px;
    img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      margin-right: 16px;
      vertical-align: middle;
    }
    span {
      font-size: 16px;
      color: #3D3D3D;
      vertical-align: middle;
    }
  }
}

/* 定义整个滚动条的样式 */
.video-chapter::-webkit-scrollbar {
  width: 4px; /* 设置滚动条的宽度 */
}
 
/* 定义滚动条轨道的样式 */
.video-chapter::-webkit-scrollbar-track {
  background: #191919; /* 设置轨道的背景颜色 */
}
 
/* 定义滚动条滑块的样式 */
.video-chapter::-webkit-scrollbar-thumb {
  background: #fff; /* 设置滑块的背景颜色 */
  border-radius: 2px;
}
</style>

<style lang="scss" scoped>
.video-box {
  :deep(.vjs-custom-skin > .video-js .vjs-big-play-button) {
    outline: none;
    border: none;
    width: 66px;
    height: 66px !important;
    background-color: rgba(0,0,0,0) !important;
  }
  :deep(.video-js .vjs-big-play-button .vjs-icon-placeholder:before) {
    content: '';
    width: 66px;
    height: 66px;
    background: url('../../assets/play.png') no-repeat;
    background-size: 100% 100%;
  }
  :deep(.vjs-custom-skin > .video-js .vjs-progress-control.vjs-control) {
    pointer-events: none !important;
  }
  // :deep(.video-js.vjs-fluid) {
  //   height: 477px;
  // }
  :deep(.vjs-poster) {
    background-size: cover;
  }
}
</style>